import { InstitutionAccountTypeEnum } from "~/graphql/supergraphEnums";

export const GUIDED_CREATION_EXCLUDED_INSTITUTION_TYPES = new Set([
  InstitutionAccountTypeEnum.Joint,
  InstitutionAccountTypeEnum.JointOther,
  InstitutionAccountTypeEnum.Tic,
  InstitutionAccountTypeEnum.SelfDirectedIra,
  InstitutionAccountTypeEnum.IraOrNonUs,
]);

// User will select a string (the key) and we'll translate that to an enum (the value):
export const VIEWABLE_ACCOUNT_TO_ACCOUNT_TYPE: { [key: string]: InstitutionAccountTypeEnum } = {
  Corporation: InstitutionAccountTypeEnum.Corporation,
  "IRA or Non-US Retirement Account": InstitutionAccountTypeEnum.IraOrNonUs,
  Joint: InstitutionAccountTypeEnum.Joint,
  "Other Joint Ownership": InstitutionAccountTypeEnum.JointOther,
  "Limited Liability Company (LLC)": InstitutionAccountTypeEnum.Llc,
  "Non-Profit": InstitutionAccountTypeEnum.NonProfit,
  "501(c)(3)": InstitutionAccountTypeEnum.Field_501c3,
  Partnership: InstitutionAccountTypeEnum.Partnership,
  TIC: InstitutionAccountTypeEnum.Tic,
  Trust: InstitutionAccountTypeEnum.Trust,
  "Self-Directed Retirement Account": InstitutionAccountTypeEnum.SelfDirectedIra,
  "Revocable Trust": InstitutionAccountTypeEnum.RevocableTrust,
  "Irrevocable Trust": InstitutionAccountTypeEnum.IrrevocableTrust,
  "Designated Activity Company (DAC)": InstitutionAccountTypeEnum.Dac,
  "Société à Responsabilité Limitée (S.A.R.L.)": InstitutionAccountTypeEnum.Sarl,
  "Société Anonyme (S.A.)": InstitutionAccountTypeEnum.Sa,
  "BVI Private Trust Company (PTC)": InstitutionAccountTypeEnum.Ptc,
  "Segregated Portfolio Company (SPC)": InstitutionAccountTypeEnum.Spc,
  "Limited Liability Partnership (LLP)": InstitutionAccountTypeEnum.Llp,
  "Private Limited Company (Ltd)": InstitutionAccountTypeEnum.Ltd,
  "Gesellschaft mit beschränkter Haftung (GmbH)": InstitutionAccountTypeEnum.Gmbh,
  "Aktiengesellschaft (AG)": InstitutionAccountTypeEnum.Ag,
  "Public Limited Company (PLC)": InstitutionAccountTypeEnum.Plc,
  "Limited Liability Limited Partnership (LLLP)": InstitutionAccountTypeEnum.Lllp,
  Foundation: InstitutionAccountTypeEnum.Foundation,
  "Employee Benefit Plan, Trust, or Pension Plan": InstitutionAccountTypeEnum.EmployeePension,
  "State or Municipal Government Pension Plan": InstitutionAccountTypeEnum.PensionPlan,
  "Sovereign Entity": InstitutionAccountTypeEnum.Sovereign,
  "Custodian, Nominee or Agent": InstitutionAccountTypeEnum.Custodian,
  Other: InstitutionAccountTypeEnum.Other,
};

export const ACCOUNT_TYPES: string[] = Object.keys(VIEWABLE_ACCOUNT_TO_ACCOUNT_TYPE);

export const ACCOUNT_TYPE_TO_VIEWABLE_ACCOUNT: { [key: string]: string } = {
  individual: "Individual",
  corporation: "Corporation",
  field_501c3: "501(c)(3)",
  ira: "IRA or Non-US Retirement Account",
  joint: "Joint",
  joint_other: "Other Joint Ownership",
  llc: "Limited Liability Company (LLC)",
  non_profit: "Non-Profit",
  other: "Other",
  partnership: "Partnership",
  tic: "TIC",
  trust: "Trust",
  ira_or_non_us: "IRA or Non-US Retirement Account",
  self_directed_ira: "Self-Directed Retirement Account",
  revocable_trust: "Revocable Trust",
  irrevocable_trust: "Irrevocable Trust",
  dac: "Designated Activity Company (DAC)",
  sarl: "Société à Responsabilité Limitée (S.A.R.L.)",
  sa: "Société Anonyme (S.A.)",
  ptc: "BVI Private Trust Company (PTC)",
  spc: "Segregated Portfolio Company (SPC)",
  llp: "Limited Liability Partnership (LLP)",
  ltd: "Private Limited Company (Ltd)",
  gmbh: "Gesellschaft mit beschränkter Haftung (GmbH)",
  ag: "Aktiengesellschaft (AG)",
  plc: "Public Limited Company (PLC)",
  lllp: "Limited Liability Limited Partnership (LLLP)",
  foundation: "Foundation",
  employee_pension: "Employee Benefit Plan, Trust, or Pension Plan",
  pension_plan: "State or Municipal Government Pension Plan",
  sovereign: "Sovereign Entity",
  custodian: "Custodian, Nominee or Agent",
};
